import axios from 'axios';
import OperationTypes from '../../../types';
import { ServerSideTypes } from '../../common/OperationCommonTypes';

export interface IFilterDeliveryNote {
    tenant?: string;
    number?: string;
    startStationId?: number;
    startDateFrom?: string | null;
    startDateTo?: string | null;
    endStationId?: number;
    endDateFrom?: string | null;
    endDateTo?: string | null;
}

const DeliveryNoteService = {
    get: {
        filterDeliveryNote: (data: IFilterDeliveryNote, serverParams: ServerSideTypes.IParams) => {
            return axios
                .get<ServerSideTypes.IResult<OperationTypes.DeliveryNote>>('masterdatatransportation/deliverynote', {
                    params: { ...data, ...serverParams },
                })
                .then((response) => response.data);
        },
        exportDeliveryNote: (
          data: IFilterDeliveryNote,
        ) => {
          return axios
            .get<any>(
              "/masterdatatransportation/deliverynote/excel",
              {
                params: { ...data },
                responseType:"arraybuffer",
              }
            )
        },
        allLocation: (params: any) => {
            return axios
                .get('masterdatasupplier/location/locationsByFilters', {
                    params: params,
                })
                .then((response) => response.data);
        },
        byId: (tenant: string, id: number) => {
            return axios
                .get<OperationTypes.DeliveryNote>(`/masterdatatransportation/deliverynote/${id}`, {
                    params: { tenant: tenant },
                })
                .then((response) => response.data);
        },
        // locationsByBpCodes: (tenant: string, bpCodes: string) => {
        //     return axios
        //         .get<any>('/masterdatasupplier/locationsByBpCodes', {
        //             params: { tenant: tenant, bpCodes: bpCodes },
        //         })
        //         .then((response) => {
        //             return response.data[bpCodes];
        //         });
        // },

        downloadPdf: (tenant: string, id: number | undefined) => {
            return axios
                .get<any>(`/masterdatatransportation/deliveryNote/${id}/file`, {
                    params: { tenant: tenant },
                    responseType: 'blob',
                })
                .then((response) => {
                    return response;
                });
        },
        damageDetailsbyid: (tenant: string, idDamages: (number | undefined)[]) => {
            return axios.get<OperationTypes.Damage[]>(`/masterdatadamage/damage/detailsbyid?tenant=${tenant}${idDamages.map(element => `&idDamages=${element}`).join("")}`).then(
                (response) => response.data,
            )
        },
        equipmentDetailsbyid: (tenant: string, idEquips: (number | undefined)[]) => {
            return axios.get<OperationTypes.Equipmet[]>(`/masterdatadamage/equipments/detailsbyid?tenant=${tenant}${idEquips.map(element => `&idEquips=${element}`).join("")}`).then(
                (response) => response.data,
            )
        }
    },

    //   update: {
    //     unavailabilityReasons: (vehicleId: number, unavailabilityReasonRequests : IUnavailabilityReasonRequest[]) => {
    //       unavailabilityReasonRequests.forEach(element => {
    //         if (dayjs(element.actualStartUnavailabilityDatetime).isAfter(dayjs())) {
    //           element.actualStartUnavailabilityDatetime = null;
    //         }
    //       });

    //       const req = {vehicleId, unavailabilityReasonRequests};

    //       return axios.post("masterdatavehicle/unavailability/setUnavailabilityReasons", req).then(
    //         response => response.data,
    //       )
    //     },
    //     changeAvailabilityReason: (vehicleId: number, availabilityCode: string) => {
    //       const data = { vehicleId, availabilityCode };
    //       return axios.post<OperationTypes.VehicleAvailability.Status>("masterdatavehicle/unavailability/changeAvailabilityReason", data).then(
    //         response => response.data
    //       )
    //     }
    //   }
};

export default DeliveryNoteService;
